import { FETCH_SALES_REQUEST, FETCH_SALES_SUCCESS, FETCH_SALES_FAILURE } from "../actions/salesActions";

const initialState = {
    loading: false,
    salesData: [],
    error: null
};

const salesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SALES_REQUEST:
            return { ...state, loading: true };

        case FETCH_SALES_SUCCESS:
            return { ...state, loading: false, salesData: action.payload };

        case FETCH_SALES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};

export default salesReducer;
